var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnedInNot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.128 20.485l-6.129-4.714-6.128 4.714V5.4c0-.5.185-.98.513-1.334a1.69 1.69 0 011.238-.552h8.755c.464 0 .91.199 1.238.552.328.354.513.834.513 1.334v15.085z",
    strokeWidth: 1.28565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTurnedInNot;